import {
  PermissionsActions,
  PermissionsActionTypes,
} from './permissions.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Permission } from '@account-users/account/models/Permission';

export const PERMISSIONS_FEATURE_KEY = 'permissions';

export interface PermissionsState extends EntityState<Permission> {
  userPermissions: Permission[];
  isLoadingPermissions: boolean;
}

const adapter: EntityAdapter<Permission> = createEntityAdapter<Permission>({
  selectId: (permission) => permission,
});

export const initialState: PermissionsState = {
  ids: [],
  entities: {},
  userPermissions: [],
  isLoadingPermissions: false,
};

export function reducer(
  state: PermissionsState = initialState,
  action: PermissionsActions,
): PermissionsState {
  switch (action.type) {
    case PermissionsActionTypes.LoadPermissionsSuccess: {
      return adapter.setAll(action.payload, {
        ...state,
        userPermissions: action.payload,
        isLoadingPermissions: false,
      });
    }
    default:
      return state;
  }
}

const { selectEntities } = adapter.getSelectors();

export const getAllPermissions = selectEntities;
